module.exports = __webpack_public_path__ + "img/waist.8efdc6a8.png";